<div id="managePopUp">
    <div class="modal-header">
        <span *ngIf="affiliationType == 'MILITARY' || (affiliationType == 'FIRST_RESPONDER' && status == 'REVERIFY')" class='modal-title'>{{authoringContentData?.militaryUploadDocument?.documentPopUpHeader}}</span>
        <span *ngIf="affiliationType == 'FIRST_RESPONDER' && status != 'REVERIFY'" class='modal-title'>{{authoringContentData?.firstResponders?.docUploadTitle}}</span>
    </div>
    <div *ngIf="affiliationType == 'MILITARY'" class="modal-body">
        <div>
            <p class="headerPart">{{authoringContentData?.militaryUploadDocument?.documentPopUpPara1}}
            <span class="headerPart sheerId">{{authoringContentData?.militaryUploadDocument?.documentPopUpSheerId}}</span>
            <span class="headerPart">{{authoringContentData?.militaryUploadDocument?.documentPopUpContent1}}</span></p>
            <p class="headerPart">{{authoringContentData?.militaryUploadDocument?.documentPopUpPara2}}
            <span class="headerPart faq" href="javascript:void(0)" (click)="redirectToMilitaryFAQ()">{{authoringContentData?.militaryUploadDocument?.documentPopUpReadFAQ}}</span>
            <span class="headerPart">{{authoringContentData?.militaryUploadDocument?.documentPopUpOr}}</span>
            <span class="headerPart contact">{{authoringContentData?.militaryUploadDocument?.documentPopUpContent2}}</span></p>
          </div>
        <div>
            <p class="detailsSection"><span class="boldFont">{{authoringContentData?.militaryVerification?.name}}:  </span><span class="input">{{name}}</span></p>
            <p class="detailsSection"><span class="boldFont">{{authoringContentData?.militaryVerification?.emailAddress}}:  </span><span class="input">{{email}}</span></p>
            <p *ngIf="infoApiFailed" class="detailsSection boldFont">
                <strong>{{authoringContentData?.affiliation?.docUploadSucccessButWithTechIssues}}</strong>
            </p>
        </div>
    </div>
    <div *ngIf="affiliationType == 'FIRST_RESPONDER'" class="modal-body">
        <div *ngIf="status != 'REVERIFY'">
            <p class="headerPart">{{authoringContentData?.firstResponders?.docUploadBodyP1}} </p>
            <p class="headerPart">{{authoringContentData?.firstResponders?.docUploadBodyP2}} </p>
        </div>
        <div *ngIf="status == 'REVERIFY'">
            <p class="headerPart">{{authoringContentData?.militaryUploadDocument?.documentPopUpPara1}}
            <span class="headerPart sheerId">{{authoringContentData?.militaryUploadDocument?.documentPopUpSheerId}}</span>
            <span class="headerPart">{{authoringContentData?.firstResponders?.documentPopUpContentReverify}}</span></p>
            <p class="headerPart">{{authoringContentData?.militaryUploadDocument?.documentPopUpPara2}}
            <span class="headerPart">{{authoringContentData?.militaryVerificationAuthoring?.subHeaderHiglightedContent2}}</span></p>
        </div>
        <div>
            <p *ngIf="name" class="detailsSection"><span class="boldFont">{{authoringContentData?.militaryVerification?.name}}:  </span><span class="input">{{name}}</span></p>
            <p *ngIf="email" class="detailsSection"><span class="boldFont">{{authoringContentData?.militaryVerification?.emailAddress}}:  </span><span class="input">{{email}}</span></p>
            <p *ngIf="infoApiFailed" class="detailsSection boldFont">
                <strong>{{authoringContentData?.affiliation?.docUploadSucccessButWithTechIssues}}</strong>
            </p>
        </div>
    </div>
    <div class="modal-footer pb-5 pull-right bottom_aligner">
        <button type='button' class='primary_btn' id='doneButton' (click)="close()">{{authoringContentData?.militaryVerification?.DoneCTA}}</button>
    </div>
</div>